import { get } from '../api/base';
import store from '../store/store';

const DEFAULT_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const sanitizeFileName = (value?: string) => {
  if (!value) {
    return 'proyecto';
  }
  return value.replace(/[^\w.-]+/g, '_');
};

const buildFallbackName = (prefix: string, projectName?: string) => {
  const date = new Date().toISOString().split('T')[0];
  return `${prefix}_${sanitizeFileName(projectName)}_${date}.xlsx`;
};

const getFilenameFromDisposition = (
  disposition?: string,
  fallback?: string,
) => {
  if (disposition) {
    const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
    if (match && match[1]) {
      return match[1].replace(/['"]/g, '');
    }
  }
  return fallback || 'reporte_acciones.xlsx';
};

const performReportDownload = async (
  endpoint: string,
  fallbackName: string,
) => {
  const state = store.getState();
  const token = state.user?.access;

  if (!token) {
    throw new Error('Token de autenticación no disponible');
  }

  const response = await get(
    endpoint,
    {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  const headers = response?.headers ?? {};
  const contentType =
    headers['content-type'] || headers['Content-Type'] || DEFAULT_MIME;
  const contentDisposition =
    headers['content-disposition'] || headers['Content-Disposition'];

  const filename = getFilenameFromDisposition(
    contentDisposition,
    fallbackName,
  );

  const blob = new Blob([response.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const downloadProjectActionsReport = async (
  projectId: number,
  projectName?: string,
) => {
  const fallbackName = buildFallbackName('reporte_acciones', projectName);
  await performReportDownload(
    `reports/project/${projectId}/actions_list/`,
    fallbackName,
  );
};

export const downloadProjectNodesReport = async (
  projectId: number,
  projectName?: string,
) => {
  const fallbackName = buildFallbackName('reporte_nodos', projectName);
  await performReportDownload(
    `reports/project/${projectId}/nodes_list/`,
    fallbackName,
  );
};

export const downloadProjectFullReport = async (
  projectId: number,
  projectName?: string,
) => {
  const fallbackName = buildFallbackName('reporte_proyecto', projectName);
  await performReportDownload(
    `reports/project/${projectId}/full/`,
    fallbackName,
  );
};
